import axios from "axios"

// export const saveChangePassword = async (values) => {
//     let data = {
//         rowkey: values.rowKey,
//         Password: values.oldpassword,
//         newPassword: values.newpassword,
//         confirmPassword: values.confirmpassword,
//         timestamp: values.timestamp
//     }
//     try {
//         const res = await axios.post(`/api/Member/ChangePassword`, data);
//         if (res && res.status === 200) {
//             return res.data;
//         } else {
//             return res.status;
//         }
//     } catch (error) {
//         if (error.response.status === 401) {
//             return error.response.status;
//         }
//     }
// }
export const submitChangePasswordFromUI = async (values) => {
    let data = {
        UserId: values.userId,      
        Password: values.newPassword   
    }
    try {
        const res = await axios.post(`/api/User/PasswordChangeFromUI`, data);
        if (res && res.status === 200) {
            return res.data;
        } else {
            return res.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}
export const submitChangePassword = async (values,isMember) => {
    let dataUser = {
        UserKey: values.rowKey,
        UserId: values.UserId,
        UserName: values.UserName,
        UserImages: values.UserImages,
        IsForceToChangePW: values.IsForceToChangePW,
        IsFailAttempts: values.IsFailAttempts,
        Password: values.password,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
        timestamp: values.timestamp
    }
    let dataMember = {
        RowKey: values.rowKey,
        UserId: values.UserId,
        Name: values.UserName,
        Photos: values.UserImages,
        ForceToChangePW: values.IsForceToChangePW,
        FailAttempts: values.IsFailAttempts,
        Password: values.password,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
        timestamp: values.timestamp
    }
    try {
        let res;
        if(isMember){          
            res = await axios.post(`/api/Member/PasswordChange`, dataMember);
        }else{
            res = await axios.post(`/api/User/PasswordChange`, dataUser);
        }
        if (res && res.status === 200) {
            return res.data;
        } else {
            return res.status;
        }
    } catch (error) {
        if (error.response.status === 401) {
            return error.response.status;
        }
    }
}